<template>
  <div>
    <div class="tw-flex">
      <label
        v-if="hasLabel"
        v-text="label"
        :for="id"
        :class="{'tw-text-red': hasError}"
        class="tw-mr-2"
      ></label>
      <span v-if="required" class="text-danger">*</span>
    </div>
    <div v-if="hasError" class="tw-h-10 tw-flex">
      <small class="tw-text-red tw-mt-1" v-text="this.error"></small>
    </div>
    <select
      :name="name"
      :id="id"
      class="form-control"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholder"
      @keyup.enter="onEnter"
      v-model="selected"
    >
      <slot></slot>
      <option
        v-for="option in options"
        :value="option"
        v-text="option"
      ></option>
    </select>
  </div>
</template>

<script>
  import inputMixin from './input';

  export default {
    name: 'BlastSelect',

    mixins: [
      inputMixin,
    ],

    props: {
      options: { required: false },
      value: { required: false },
    },

    data() {
      return {
        selected: null,
      };
    },

    watch: {
      selected(value) {
        this.$emit('input', value);
      },

      value(newValue) {
        this.selected = newValue;
      },
    },

    computed: {
      hasLabel() {
        return !!this.label;
      },
    },

    mounted() {
      this.selected = this.value;
    },
  };
</script>
